// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__EowpK","dark":"Breadcrumb_dark__AOGb8"};